<script lang="ts" setup>
const navItems = useSupportList();
</script>

<template>
    <section class="services-container">
        <mr-typography weight="500" size="display4" align="center">
            پشتیبانی 24 ساعته
        </mr-typography>
        <mr-divider :thickness="1" class="support-divider" />
        <div class="services">
            <div
                v-for="{ icon, label, click } in navItems"
                :key="toValue(label)"
                rel="nofollow"
                class="service"
                prefetch
                @click="click()"
            >
                <div class="icon-wrapper">
                    <mr-icon size="x-large" :icon color="var(--blue-400)" />
                </div>
                <mr-typography weight="600">{{ label }}</mr-typography>
            </div>
        </div>
    </section>
</template>

<style>
.support-divider {
    width: 100%;
    padding: 8px;
}
.services-container {
    display: flex;
    flex-direction: column;
    padding: 20px;
    gap: 20px;
    background-color: white;
    border-radius: 12px;
    .services {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        row-gap: 20px;
        margin-inline: -16px;
        padding-top: 10px;
        .service {
            all: unset;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 8px;
            cursor: pointer;
            .icon-wrapper {
                background-color: white;
                padding: 16px;
                border-radius: 16px;
            }
        }
    }
}
</style>
